enum InviteCTATypeEnum {
  Register = 0,
  EditResponse = 1,
  EventAccess = 2,
}

export default InviteCTATypeEnum;
